export type WeddingThemeColors = {
  primaryColor?: string | null;
  secondaryColor?: string | null;
};

const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;

export function isValidHexColor(
  value: string | null | undefined,
): value is string {
  return typeof value === "string" && HEX_COLOR_PATTERN.test(value);
}

function linearizeChannel(channel: number): number {
  return channel <= 0.03928
    ? channel / 12.92
    : ((channel + 0.055) / 1.055) ** 2.4;
}

/**
 * WCAG relative luminance, thresholded at 0.5 — used to decide whether a
 * hex color needs black or white text on top of it.
 */
export function getContrastTextColor(hex: string): "#000000" | "#ffffff" {
  const r = linearizeChannel(parseInt(hex.slice(1, 3), 16) / 255);
  const g = linearizeChannel(parseInt(hex.slice(3, 5), 16) / 255);
  const b = linearizeChannel(parseInt(hex.slice(5, 7), 16) / 255);

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance > 0.5 ? "#000000" : "#ffffff";
}
